/**
 * The collab client, loaded on demand. It bundles the agent compiler, so it
 * stays out of the editor's chunk and is fetched only once live editing is on.
 */
export const loadCollabClient = () =>
  import('@pypestream/pro-studio-collab-client');
